var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.6,19.2v11.1h-6.4V20c0-2.6-0.9-4.4-3.3-4.4c-1.8,0-2.8,1.2-3.3,2.4c-0.2,0.4-0.2,1-0.2,1.6v10.8h-6.4 c0,0,0.1-17.5,0-19.3h6.4v2.7c0,0,0,0,0,0.1h0v-0.1c0.9-1.3,2.4-3.2,5.8-3.2C27.4,10.5,30.6,13.3,30.6,19.2z M4.2,1.7 C2,1.7,0.6,3.1,0.6,5c0,1.9,1.4,3.3,3.6,3.3h0c2.2,0,3.6-1.5,3.6-3.3C7.8,3.1,6.4,1.7,4.2,1.7z M1,30.3h6.4V11H1V30.3z"
  }))));
}

export default SvgLinkedin;